module.exports = __webpack_public_path__ + "img/icon_am_code.fafbea4e.png";